import React from "react"
import PropTypes from "prop-types"
import { useIndicadoresFiltrosStore } from "store/useIndicadoresFiltrosStore"
import { useAPI } from "hooks/useAPI"
import { Card, CardBody, CardHeader, Spinner } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import { format } from "date-fns"
import { getHexColorByClassName } from "helpers"

const SLAEntrega = props => {
  const REPORT_ID = 33

  const fetchReports = useIndicadoresFiltrosStore(state => state.fetchReports)
  const filtrosSelecionados = useIndicadoresFiltrosStore(
    state => state.filtrosSelecionados
  )

  const {
    payload: { data, title },
    error,
    isLoading,
  } = useAPI(REPORT_ID, filtrosSelecionados, fetchReports)

  let categories = []
  let totalData = []
  let percentData = []
  const threshold = 95

  if (data) {
    categories = data?.map(item => format(new Date(item.data), "MM/yyyy"))
    totalData = data?.map(item => Number(item.total))
    percentData = data?.map(item => parseFloat(item.percentage))
  }
  const series = [
    {
      name: "Quantidade",
      type: "column",
      data: totalData,
    },
    { name: "Percentual", type: "line", data: percentData },
  ]

  const primaryColor = getHexColorByClassName("--bs-primary")
  const infoColor = getHexColorByClassName("--bs-info")
  const successColor = getHexColorByClassName("--bs-success")
  const dangerColor = getHexColorByClassName("--bs-danger")

  const chartOptions = {
    chart: {
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    markers: {
      size: [0, 4],
    },
    stroke: {
      width: [0, 2],
      curve: "smooth",
    },
    colors: [infoColor, primaryColor],
    xaxis: {
      categories,
    },
    yaxis: [
      {
        title: { text: "Quantidade" },
      },
      {
        opposite: true,
        min: 0,
        max: 100,
        labels: {
          formatter: val => `${val}%`,
        },
        title: { text: "Percentual" },
      },
    ],
    dataLabels: {
      enabled: true,
      style: {
        colors: [
          infoColor,
          ({ seriesIndex, dataPointIndex, w }) => {
            const point = w.globals.series[seriesIndex][dataPointIndex]
            return point >= threshold ? successColor : dangerColor
          },
        ],
        fontSize: "12px",
      },
      formatter: (value, { seriesIndex }) => {
        if (seriesIndex === 1 && value != null) {
          return `${value}%`
        }
        return value
      },
    },
    tooltip: {
      shared: true,
      intersect: false,

      y: [
        { formatter: val => val },
        { formatter: val => (val !== null ? `${val}%` : "") },
      ],
    },
    legend: {
      markers: {
        fillColors: [infoColor, primaryColor],
      },
    },
  }

  return (
    <Card>
      <CardHeader tag={"h4"} className="bg-transparent border-bottom">
        {!isLoading && title}
        {isLoading && <span className="placeholder col-3"></span>}
      </CardHeader>
      <CardBody>
        {isLoading && (
          <div className="mt-3" style={{ textAlign: "center" }}>
            <Spinner
              className="ms-2"
              style={{ width: "4rem", height: "4rem" }}
              color="primary"
            />
          </div>
        )}
        {!isLoading && (
          <ReactApexChart
            options={chartOptions}
            series={series}
            type="line"
            height={400}
            className="apex-charts"
          ></ReactApexChart>
        )}
      </CardBody>
    </Card>
  )
}

SLAEntrega.propTypes = {}

export default SLAEntrega
